import { render, staticRenderFns } from "./EpsBlockedAttachmentTypesFormDialog.vue?vue&type=template&id=b31b9ac4&"
import script from "./EpsBlockedAttachmentTypesFormDialog.vue?vue&type=script&lang=js&"
export * from "./EpsBlockedAttachmentTypesFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports